import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/pages/index'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
]

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    let ua = navigator.userAgent;
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
    if (isMobile && window.location.href.indexOf('mobile.html') === -1) {
        window.location.href = "/mobile.html";
    } else {
        next();
    }
})

export default router
